import React from "react";
import { generateRandomString } from "../functions/general";
export default class Circle extends React.Component {
  render() {
    var id = "circle_" + generateRandomString();
    var style = {
      width: this.props.size + "px",
      height: this.props.size + "px",
      borderColor: this.props.color,
      borderRadius: "50%"
    };
    return (
      <div>
        <div className="circle" id={id} style={style} />
      </div>
    );
  }
}
Circle.defaultProps = {
  color: "white",
  size: 50,
  borderWidth: 4,
  duration: "1s",
  animate: true
};



// WEBPACK FOOTER //
// ./src/components/circle.js